<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-apply">兑换道具</div>
                    <div class="pay-view">
                        <div class="goods-detail">
                            <div class="goods-wrapper">
                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                            </div>  
                        </div>                        
                    </div>

                    <div class="item-name">{{ item.giftName }}</div>
                                   
                    <div class="calc-view">
                        <div class="amount calc-item">
                            <div class="calc-label"><div class="label-amount">兑换数量：</div></div>
                            <van-stepper v-model="value" :max="max ? max : 999" integer />
                        </div>
                        <div class="total calc-item">
                            <div class="calc-label"><div class="label-cost">总消耗：</div></div>
                            <span class="price">积分<b>*{{ value * item.amt }}</b></span>
                        </div>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="apply"></div>                       
                    </div>
                    
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{

}

.dialog-title.t-apply{
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 400;
}

.pay-view{
    display: flex;
    justify-content: center;
    align-items: center;
}

.pay-view p{
    padding: 0 20px;
    line-height: 1.8;
}

.pay-view b{
    /* color: #fe5a1e; */
}

.goods-detail{
    .goods-wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto 20px;
        border: 3px solid #e3e1dc;
        border-radius: 14px;
        box-sizing: border-box;
        // background-image: url(~@/assets/images/shop/bg-item.png);
        width: 100px;
        height: 100px;
    }

    .goods-pic{
        width: 69px;
        height: 69px;
    }
}

.item-name{
    margin-top: -15px;
    margin-bottom: 10px;
    color: #666565;
    text-align: center;
}

.calc-item{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 55px;
    margin-bottom: 10px;
    color: #666565;
    // justify-content: center;

    .price{
        b{
            color: #d33d27;
        }
    }
}

.warn{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%; 
    margin-top: 15px;
    font-size: 20px;
    color: #c2393f;
    text-align: center;
    vertical-align: text-top;
}

.i-warn{
    display: inline-block;
    width: 21px;
    height: 21px;
    margin: 0 5px;
    background-image: url(~@/assets/images/modal/icon-warn.png);
    vertical-align: sub;
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 30px;
}

.u-ctrl .u-btn.ok{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}

.u-ctrl .u-btn.cancel{
    width: 190px;
    height: 54px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiScoreApply , apiScoreList } from '@/api/index';
export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '----',
            cost : 599,
            num : 1,
            score : 0,
            text : '',
            item : {},
            value : 1,
            max: 999,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    mounted(){
        this.max = this.item.max == -1 ? 999 : this.item.max - this.item.orderNum;
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        render_ex_list (){
            apiScoreList().then(
                res => {
                    this.$store.commit("$_setExList", res.data);
                }
            )
        },          
        apply(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }


            this.destroyElement();
            this.$comfirmwarn_score({
                item : this.item,
                num : this.value,
                cost : this.value * this.item.amt,
            });
            // apiScoreApply({
            //     id : this.item.id,
            //     num : this.value,
            //     gid : 6,
            // }).then(
            //     res => {
            //         this.destroyElement();
            //         this.$msg_modal('兑换成功');

            //         //todo
            //         //this.$update_evt();
            //         this.render_ex_list();                    
            //     },
            //     rej => {
            //         this.destroyElement();
            //         this.$msg_modal(rej.message);
            //     }
            // )
        },        
    },    
}
</script>